import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import RichTextEditor from '../RichTextEditor';

interface QuestionTextEditorProps {
  value: string;
  onChange: (value: string) => void;
}

const QuestionTextEditor: React.FC<QuestionTextEditorProps> = ({ value, onChange }) => {
  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
        ❓ Question Text
      </Typography>
      
      <Box sx={{ minHeight: 200 }}>
        <RichTextEditor
          value={value}
          onChange={onChange}
          placeholder="Enter your question here. You can add formatting, images, and mathematical expressions..."
          height={200}
        />
      </Box>
      
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        💡 Tip: Use the toolbar to add formatting, images, and mathematical expressions. 
        Keep questions clear and concise for better student understanding.
      </Typography>
    </Paper>
  );
};

export default QuestionTextEditor;
